export const channels = {
  webDirect: 'web-direct',
  google: 'google',
  clever: 'clever',
  classlink: 'classlink',
  mailchimp: 'mailchimp',
  facebook: 'facebook',
  youtube: 'youtube',
  admin: 'admin',
};

export const mediums = {
  organic: 'organic',
  paid: 'paid',
  email: 'email',
};

export const utmParams = {
  source: 'utm_source',
  medium: 'utm_medium',
  term: 'utm_term',
};
